import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0ee6ebfb"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main" }
const _hoisted_2 = { class: "colm1" }
const _hoisted_3 = { class: "colm2" }

import KikakuKihon from "../components/kikaku_edit/KikakuKihon.vue";
import KikakuKarisiyou from "../components/kikaku_edit/KikakuKarisiyou.vue";
import { Notyf } from "notyf";
import PankuzuHeader from "@/components/PankuzuHeader.vue";

import { useStore } from "vuex";
import axios from "axios";
import { computed, onMounted, ref } from "vue";
import { useRoute, useRouter } from "vue-router";

export default /*#__PURE__*/_defineComponent({
  __name: 'Kikaku_edit',
  props: {
  isActive_SidebarFlg: { type: Boolean },
},
  setup(__props) {

const store = useStore();
const route = useRoute();
const router = useRouter();
const notyf = new Notyf();
const kikakuId = location.search;

const kikakuData = ref();

const props = __props;

//ぱんくずヘッダー
const currentPathList =
  route.path == "/kikaku_edit"
    ? [{ name: "企画編集" }]
    : [{ name: "企画新規作成" }];

onMounted(() => {
  const fullPath = location.href;
  if (fullPath.includes("edit")) {
    axios
      .get(`${store.getters["getBaseUrl"]}/kikaku/detail${kikakuId}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        },
      })
      .then((res) => {
        kikakuData.value = res.data;
        const storePath = store.getters.getBaseUrl;
        const fullPath = location.href;
        const queryPath = location.search;
        if (fullPath.includes("new")) {
          store.commit("oldKikakuClear");
        } else if (fullPath.includes("edit"))
          store.commit("oldKikakuDataSubmit", kikakuData.value);
  
        // 確認画面の修正ボタンから遷移してきた場合
        // if (
        //   route.query.fromConfirm !== undefined &&
        //   route.query.fromConfirm === "true"
        // ) {
        //   kikakuData.value = store.state.kikakunew.responseData;
        // }
      });
  }
});

// エラーバリデーションの実施
const kikakuKihon = ref();
const kariSiyo = ref();
const validCompData = () => {
  const hasKihonError = kikakuKihon.value.validData();
  const hasKariSiyoError = kariSiyo.value.validDataKariSiyo();
  if (!hasKihonError && !hasKariSiyoError) {
    SubmitData();
  }
};
const SubmitData = () => {
  store.dispatch("submitKikakuData");
  notyf.success("登録完了");
  router.push("/kikaku");
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["area", {
      Sidebar_False: !props.isActive_SidebarFlg,
      Sidebar_True: props.isActive_SidebarFlg,
    }])
  }, [
    _createVNode(PankuzuHeader, {
      isActive_SidebarFlg: props.isActive_SidebarFlg,
      currentPathList: _unref(currentPathList)
    }, null, 8, ["isActive_SidebarFlg", "currentPathList"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(KikakuKihon, {
          kikakuData: kikakuData.value,
          ref_key: "kikakuKihon",
          ref: kikakuKihon
        }, null, 8, ["kikakuData"])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(KikakuKarisiyou, {
          kikakuData: kikakuData.value,
          ref_key: "kariSiyo",
          ref: kariSiyo
        }, null, 8, ["kikakuData"])
      ])
    ]),
    _createElementVNode("div", null, [
      _createElementVNode("button", {
        onClick: validCompData,
        class: "submit_btn"
      }, "企画登録")
    ])
  ], 2))
}
}

})